var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-state"},[_c('span',{style:({color: _vm.Constants.dossierStatus[_vm.rowData.state].color})},[_vm._v(_vm._s(_vm.Constants.dossierStatus[_vm.rowData.state].name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }